import { render } from "./CancellationRescheduling.vue?vue&type=template&id=12b0b0e2&scoped=true"
import script from "./CancellationRescheduling.vue?vue&type=script&lang=js"
export * from "./CancellationRescheduling.vue?vue&type=script&lang=js"

import "./CancellationRescheduling.vue?vue&type=style&index=0&id=12b0b0e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b0b0e2"]])

export default __exports__